export default __webpack_public_path__ + "static/media/icon-arrow-up.9f27dbc9.svg";